import ScormAPI from '@/lib/ScormApi/ScormAPI'
import JsonFormatter from '@/lib/ScormApi/JsonFormatter'
import CMI_InteractionsObjectInterface from "@/lib/ScormApi/Scorm/interfaces/CMI_InteractionsObjectInterface"

export default function CMI_InteractionsObject (API: ScormAPI): CMI_InteractionsObjectInterface {
  const jsonString = true
  let _id = ''
  let _time = ''
  let _type = ''
  let _weighting = ''
  let _student_response = ''
  let _result = ''
  let _latency = ''
  let objectives__childArray = []
  let correct_responses__childArray = []
  return {
    get id (): any {
      return (!jsonString) ? API.throwSCORMError(404) : _id
    },
    set id (id) {
      _id = id
    },
    get time (): any {
      return (!jsonString) ? API.throwSCORMError(404) : _time
    },
    set time (time) {
      _time = time
    },
    get type (): any {
      return (!jsonString) ? API.throwSCORMError(404) : _type
    },
    set type (type) {
      _type = type
    },
    get weighting (): any {
      return (!jsonString) ? API.throwSCORMError(404) : _weighting
    },
    set weighting (weighting) {
      _weighting = weighting
    },
    get student_response (): any {
      return (!jsonString) ? API.throwSCORMError(404) : _student_response
    },
    set student_response (student_response) {
      _student_response = student_response
    },
    get result (): any {
      return (!jsonString) ? API.throwSCORMError(404) : _result
    },
    set result (result) {
      _result = result
    },
    get latency (): any {
      return (!jsonString) ? API.throwSCORMError(404) : _latency
    },
    set latency (latency) {
      _latency = latency
    },
    objectives: {
      childArray: [],
      get _count () {
        return String(this.childArray.length)
      },
      set _count (_count) {
        API.throwSCORMError(402)
      },
      toJSON: new JsonFormatter().apply
    },
    correct_responses: {
      childArray: [],
      get _count () {
        return String(this.childArray.length)
      },
      set _count (_count) {
        API.throwSCORMError(402)
      },
      toJSON: new JsonFormatter().apply
    },
    toJSON: new JsonFormatter().apply
  }
}

